import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import { toast } from "react-toastify";
import { updateRadiologyApi } from "../../services/radiology.service";

export default function AddReport({ open, onClose, id, refetch }) {
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    let response;

    setLoading(true);
    response = await updateRadiologyApi(id, {
      status: "Dispatched",
      report: {
        content: value,
      },
    });
    setLoading(false);

    if (response.code === 200 || response.code === 201) {
      toast.success(`Report submitted successfully`);
      refetch();
    } else {
      toast.error(response?.message || "Some error occurred.");
    }
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            maxWidth: "unset",
            width: { xs: "95vw", lg: "1100px" },
            bgcolor: "#E5F4FF",
            borderRadius: "20px",
          },
        },
      }}
    >
      <DialogContent>
        {/* Title */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: "20px",
          }}
        >
          <Typography sx={{ color: "rgba(93, 106, 130, 1)", fontSize: 20 }}>
            Add Report
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* form */}
        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            multiline
            rows={6}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            fullWidth
            placeholder="Write your report here..."
            variant="outlined"
            InputProps={{
              sx: {
                backgroundColor: "#fff", // White background
                borderRadius: 2,
                "& fieldset": {
                  borderColor: "#ccc", // Light border color
                },
                "&:hover fieldset": {
                  borderColor: "#999", // Darker border on hover
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#0179B0", // Highlight border on focus
                },
              },
            }}
          />
          <Box sx={{ display: "flex", justifyContent: "center", mt: "20px" }}>
            <Button
              variant="contained"
              type="submit"
              sx={{
                textTransform: "none",
                backgroundColor: "rgba(1, 121, 176, 1)",
                width: "150px",
              }}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : `Submit`}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
